/**
 * @fileoverview GET handler for the "/engagement/expressive_report/table_definitions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementGetTableDefinitions } from "./constants";
import type { EngagementGetTableDefinitions, GetTableDefinitionsParams } from "./types";

export const getEngagementGetTableDefinitions = reactQueryFetcherAdapter(
  engagementGetTableDefinitions,
  (
    signal: AbortSignal,
    { schemaType, dataWarehouseConfigId }: GetTableDefinitionsParams
  ): Promise<EngagementGetTableDefinitions> => {
    return fetch(
      engagementGetTableDefinitions,
      "GET",
      { schema_type: schemaType, data_warehouse_config_id: dataWarehouseConfigId },
      { signal }
    );
  }
);
